import React,{memo} from "react";
import { connect } from "react-redux";
import { isSet } from '../../../Utils/CommonFunctions';
import StepsTreeInputContent from "./StepsTreeInputContent";



const StepsTreeElements = (props)=>{
	//console.log('render 222')
    const {arrayObjectFields,inputValuesPayload,variablesList,fieldKey,winId} = props;
		let nonArrayElement = [];
		let arrayElement = [];
		variablesList.map((item)=>{
			// console.log('arrayObjectFields',props.arrayObjectFields);
			if(item.is_request === true){
				if(isSet(item.fieldtype_name,item.field_type_name)==='Array' || isSet(item.fieldtype_name,item.field_type_name)==='Object'){
					const fields = isSet(item['fields'],[]);
					arrayElement.push({
						...item, 
						fields:fields
					})
				}else{
					nonArrayElement.push(item);
				}	
			}
			
		});
		return(
			<>
				<li className={(fieldKey==='default')?"withoutHeader":""} key={'withOutChild'+fieldKey} id={'withOutChild'+fieldKey}>
					<div className='row'>
						{
							nonArrayElement.map((item,itemIndex)=>{
								// return this.innerElements(item,winId);
								const indexing = inputValuesPayload.findIndex((i)=>i.variable_id===item.id);
								let selectedValue = '';
								try{
									selectedValue = inputValuesPayload[indexing]['values'][0]["value"];
								}catch(e){

								}								
								return(
									<StepsTreeInputContent 
										key={itemIndex}
										item={item} 
										updateValuesHandler={props.updateValuesHandler}
										formFieldsHandler={props.formFieldsHandler}
										winId={winId}
										selectedValue={selectedValue} />
								)
								
							})
						}
					</div>
				</li>
				{
					arrayElement.map((item,itemIndex)=>{
							if(isSet(item.fields,[]).length===0){return false }
							return(
									<li key={'withChild'+item.id}> <span className="treewithHeader"> {isSet(item.name,item.variable_name)} </span>  
			              				<ul className='treeSkeletonList'>
										  <StepsTreeElements 
											variablesList={isSet(item.fields,[])} 
											fieldKey={item.id}
											updateValuesHandler={props.updateValuesHandler}
											formFieldsHandler={props.formFieldsHandler}
											arrayObjectFields={arrayObjectFields}
											inputValuesPayload={inputValuesPayload}
											winId={isSet(item.window_id,winId)} />
										</ul>
			              			</li> 
										
							)
					})
				}
			</>
		)
}



const mapStateToProps = (state) => { 
    return {
       //arrayObjectFields:state.StepsFlowReducer.arrayObjectFields,
	   //inputValuesPayload:state.StepsFlowReducer.inputValuesPayload,
    };
}
export default
	connect(
		mapStateToProps, 
	  null
)(memo(StepsTreeElements));

